<div mat-dialog-content>
  <div class="mat-dialog-content">
    <div class="head-confirm-modal-list">
      <h2>Relatórios</h2>
    </div>
    <div class="footer-confirm-modal-list">
      @if (admissionString64) {
        <div class="row">
          <button mat-flat-button color="primary" class="btn-block" (click)="clickReport(admissionString64)">
            @if (!isLoading) {
              <span>Relatório de Admissão</span>
            }
            @if (isLoading) {
              <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
            }
          </button>
        </div>
      }
      <div class="row">
        <button mat-flat-button color="primary" class="btn-block" (click)="openCreateStatementOfAttendance()">
          @if (!isLoading) {
            <span>Declaração de Comparecimento</span>
          }
          @if (isLoading) {
            <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
          }
        </button>
      </div>
      @if (wristbandString64) {
        <div class="row">
          <button mat-flat-button color="primary" class="btn-block" (click)="clickReport(wristbandString64)">
            @if (!isLoading) {
              <span>Pulseira</span>
            }
            @if (isLoading) {
              <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
            }
          </button>
        </div>
      }
      @if (triageWristbandString64) {
        <div class="row">
          <button mat-flat-button color="primary" class="btn-block" (click)="clickReport(triageWristbandString64)">
            @if (!isLoading) {
              <span>Pulseira da Classificação</span>
            }
            @if (isLoading) {
              <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
            }
          </button>
        </div>
      }
      @if (triageString64) {
        <div class="row">
          <button mat-flat-button color="primary" class="btn-block" (click)="clickReport(triageString64)">
            @if (!isLoading) {
              <span>Ficha de Classificação</span>
            }
            @if (isLoading) {
              <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
            }
          </button>
        </div>
      }
      <div class="row">
        <button mat-flat-button color="accent" class="btn-block" (click)="clickCancel()">Fechar</button>
      </div>
    </div>
  </div>
</div>